import { useEffect, useState } from 'react';
import logoWhite from '../../../shared/assets/logo/liftpeak_white.png';
import appStoreBadge from '../../../shared/assets/badges/app-store-badge.svg';
import googlePlayBadge from '../../../shared/assets/badges/goole-play-badge.svg';
import {
  detectPlatform,
  getUtmParams,
  isInAppBrowser,
  STORE_LINKS,
  trackEvent,
} from '../../../shared/lib';
import './DownloadPage.css';

export function DownloadPage() {
  const [inApp] = useState(isInAppBrowser);
  const [platform] = useState(detectPlatform);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);

    const target = STORE_LINKS[platform];
    const utm = getUtmParams();
    const props = { platform, inAppBrowser: inApp, ...utm };

    let cancelled = false;

    (async () => {
      await Promise.all([
        trackEvent('Download Page Viewed', props),
        trackEvent('Redirected to Store', props),
      ]);
      if (cancelled || inApp) return;
      window.location.replace(target);
    })();

    return () => {
      cancelled = true;
      meta.remove();
    };
  }, [inApp, platform]);

  return (
    <div className="download-page">
      <div className="download-card">
        <img src={logoWhite} alt="Liftpeak" className="download-logo" />

        {inApp ? (
          <>
            <h1 className="download-title">
              Open in your browser
            </h1>
            <p className="download-subtitle">
              This link doesn&rsquo;t work inside the app.
              <br />
              Tap <strong>⋯</strong> → <strong>&ldquo;Open in browser&rdquo;</strong> to continue.
            </p>
            <div className="download-divider" />
            <p className="download-subtitle">
              Or tap your store directly:
            </p>
          </>
        ) : (
          <>
            <h1 className="download-title">Opening Liftpeak…</h1>
            <p className="download-subtitle">
              If nothing happens, pick your store below.
            </p>
          </>
        )}

        <div className="download-badges">
          {(platform === 'ios' || platform === 'desktop') && (
            <a href={STORE_LINKS.ios} className="download-badge-link">
              <img
                src={appStoreBadge}
                alt="Download on the App Store"
                className="download-badge"
              />
            </a>
          )}
          {(platform === 'android' || platform === 'desktop') && (
            <a href={STORE_LINKS.android} className="download-badge-link">
              <img
                src={googlePlayBadge}
                alt="Get it on Google Play"
                className="download-badge"
              />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default DownloadPage;
